export default __webpack_public_path__ + "static/media/Call.ec411542.svg";